import { I18NEXT_LANG } from './constants/cookies';
import { LANG, LOCALIZATIONS, RESOURCES } from './constants/localization';
import { LOCALIZATION } from './constants/localStorage';
import { getCurrentLanguage } from './helpers/localization';
import i18n, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from "./locales/en/translation.json";
import viTranslation from "./locales/vi/translation.json";

const initOptions = {
  resources: RESOURCES,
  fallbackLng: LOCALIZATIONS.en,
  lng: getCurrentLanguage(),

  supportedLngs: [LOCALIZATIONS.vi, LOCALIZATIONS.en],
  preload: [LOCALIZATIONS.vi, LOCALIZATIONS.en],

  // 'all' --> ['en-US', 'en', 'dev']
  // 'currentOnly' --> 'en-US'
  // 'languageOnly' --> 'en'
  load: 'languageOnly',

  // not needed for react as it escapes by default
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },

  // Start: LanguageDetector config
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  detection: {
    // order and from where user language should be detected
    order: [
      'querystring',
      'cookie',
      'localStorage',
      'htmlTag',
      'path',
      'navigator',
    ],

    // keys or params to lookup language from
    lookupCookie: I18NEXT_LANG,
    lookupQuerystring: LANG,
    lookupLocalStorage: LOCALIZATION,
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,

    // cache user language on
    caches: ['localStorage', 'cookie'],

    // optional expire and domain for set cookie
    cookieMinutes: 10,
    cookieDomain: window.location.hostname,

    // optional htmlTag with lang attribute, the default is:
    htmlTag: document.documentElement,
  },
  // End: LanguageDetector config
};

i18n
  // passes i18n down to react-i18next
  .use(initReactI18next)

  // initial i18n
  .init(initOptions);

export default i18n;